"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_sortable_hoc_1 = require("react-sortable-hoc");
exports.arrayMove = react_sortable_hoc_1.arrayMove;
var styled_1 = __importDefault(require("../../styled"));
var item_1 = __importDefault(require("./item"));
var tokens_1 = require("../../tokens");
var automation_attribute_1 = __importDefault(require("../../_helpers/automation-attribute"));
var container_styles_1 = __importDefault(require("../../_helpers/container-styles"));
var sortable_handle_1 = __importDefault(require("./sortable-handle"));
var ResourceList = function (props) {
    var defaultItemRenderer = function (item, _, index) {
        var draggingMode = document.querySelector('.cosmos-dragging');
        return (React.createElement(item_1.default, __assign({ index: index, draggingMode: draggingMode, reorderHandle: props.sortable ? sortable_handle_1.default : null, item: item }, item)));
    };
    var itemRendererBuilder = function (props) {
        var item = props.item, index = props.index, actions = props.actions, renderItem = props.renderItem, onItemClick = props.onItemClick, accessibilityIndex = props.accessibilityIndex, accessibilityOnSortEnd = props.accessibilityOnSortEnd;
        var itemRenderer = renderItem || defaultItemRenderer;
        var actualIndex = index || accessibilityIndex;
        var handleOnItemClick = function (evt) {
            if (typeof onItemClick === 'function') {
                onItemClick(evt, item);
            }
        };
        return React.cloneElement(itemRenderer(item, props, actualIndex), {
            item: item,
            key: actualIndex,
            index: actualIndex,
            accessibilityOnSortEnd: accessibilityOnSortEnd,
            actions: item.actions || actions,
            onClick: item.onClick || handleOnItemClick
        });
    };
    var defaultChildrenRenderer = function (_a) {
        var items = _a.items, actions = _a.actions, onItemClick = _a.onItemClick, renderItem = _a.renderItem;
        return items.map(function (item, index) {
            return itemRendererBuilder({ item: item, index: index, renderItem: renderItem, onItemClick: onItemClick, actions: actions });
        });
    };
    var SortableResourceListItem = react_sortable_hoc_1.SortableElement(function (_a) {
        var item = _a.item, actions = _a.actions, renderItem = _a.renderItem, accessibilityIndex = _a.accessibilityIndex, onItemClick = _a.onClick, accessibilityOnSortEnd = _a.accessibilityOnSortEnd;
        return itemRendererBuilder({
            item: item,
            actions: actions,
            renderItem: renderItem,
            accessibilityIndex: accessibilityIndex,
            onItemClick: onItemClick,
            accessibilityOnSortEnd: accessibilityOnSortEnd
        });
    });
    var SortableResourceList = react_sortable_hoc_1.SortableContainer(function (_a) {
        var sortableItems = _a.items, actions = _a.actions, onItemClick = _a.onItemClick, renderItem = _a.renderItem, accessibilityOnSortEnd = _a.accessibilityOnSortEnd;
        return (React.createElement("div", null, sortableItems.map(function (item, index) { return (React.createElement(SortableResourceListItem, { actions: item.actions || actions, onClick: item.onClick || onItemClick, item: item, key: index, accessibilityIndex: index, accessibilityOnSortEnd: accessibilityOnSortEnd, index: index, renderItem: renderItem })); })));
    });
    var sortableChildrenRenderer = function (props) {
        return (React.createElement(SortableResourceList, __assign({}, props, { useDragHandle: true, helperClass: "cosmos-dragging", accessibilityOnSortEnd: props.onSortEnd })));
    };
    var resolveChildrenRenderer = function (props) {
        return props.sortable ? sortableChildrenRenderer(props) : defaultChildrenRenderer(props);
    };
    return (React.createElement(ResourceList.Element, __assign({}, automation_attribute_1.default('resource-list'), props), resolveChildrenRenderer(props)));
};
ResourceList.Element = styled_1.default.ul(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n\n  margin: ", " 0;\n  padding: 0;\n"], ["\n  ", ";\n\n  margin: ", " 0;\n  padding: 0;\n"])), container_styles_1.default, tokens_1.spacing.large);
ResourceList.Item = item_1.default;
exports.default = ResourceList;
var templateObject_1;
//# sourceMappingURL=resource-list.js.map